import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("jsgHa"), parcelRequire.load("7SFJY"), parcelRequire.load("glNyF"), parcelRequire.load("c6gg0"), parcelRequire.load("hLWGj"), parcelRequire.load("7UfgP"), parcelRequire.load("3jckR"), parcelRequire.load("2nucT")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jsgHa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("7SFJY")} />
  <link rel="modulepreload" href={parcelRequire.resolve("glNyF")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c6gg0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hLWGj")} />
  <link rel="modulepreload" href={parcelRequire.resolve("7UfgP")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3jckR")} />
  <link rel="modulepreload" href={parcelRequire.resolve("2nucT")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
